<ng-container *ngIf="vm$ | async as vm">
    <uni-label [required]="true">
        {{'ci.common.reportFrequency' | translate}}
    </uni-label>
    <app-form-single-select
        (valueChange)="frequencyChange($event)"
        [value]="vm.value"
        [options]="vm.entities"
        [canClear]="false"
        [placeholder]="'ci.common.reportFrequency' | translate"
    ></app-form-single-select>
</ng-container>